export function getASILoginPrompt(asi_login_label, fin_aid_enabled, school_name, financial_aid_name = 'financial aid') {
	if (asi_login_label && fin_aid_enabled) {
		return `To charge your student account please sign in with your ${asi_login_label}`;
	} else if (asi_login_label && !fin_aid_enabled) {
		return `Sign in with your ${asi_login_label}`;
	} else {
		return (fin_aid_enabled ? `To use your ${financial_aid_name.toLowerCase()} please sign in` : 'Sign in') +
			` with your ${school_name} Account`;
	}
}

export function getFinAidAppliedAmountLabel(globs) {
	return globs && globs['financial_aid_information'] && globs['financial_aid_information']['payment_voucher_label_total']
		? globs['financial_aid_information']['payment_voucher_label_total'] : 'Financial Aid';
}

export function getVoucherAppliedAmountLabel(globs) {
	if(globs && globs['institute_id'] === 1906) { // houghton
		return 'Applied to StudentID#';
	}
	if(globs && [400, 1086].indexOf(globs['institute_id']) !== -1) { //lynchburg, emu
		return 'Student Account'
	}

	return globs && globs['voucher_name'] ? globs['voucher_name'] : 'Voucher';
}

export function getCCPaymentLabel(globs) {
	return !globs || !globs['flex_pay_store'] ? 'Credit Card' : 'Flexpay';
}

export function getSummaryCaption(globs, key, is_incomplete) {

	switch (key) {
		case 'shipping':
			return globs['is_vie'] ? 'Shipping and VIE Fees' : 'Shipping';

		case 'subtotal':
			return 'Subtotal';

		case 'tax':
			return 'Tax';

		case 'discount':
			return 'Discount';

		case 'total':
			return is_incomplete ? 'Estimated Total' : 'Order Total';

	}

	return key;
}

export function getPaymentMethodsTip(globs, section) {
	const tips = [];

	if (section['group'] === 'exchange' && section['books'].length > 0) {
		const book = section['books'][0];
		if (book && book['seller_name'] && book['seller_state'] && book['seller_city']) {
			tips.push(`<span class="csst-normal">Ships directly from <strong>${book['seller_name']}</strong> in <strong>${book['seller_city']}, ${book['seller_state']}</strong></span>`);
		}
	}

	if (section['group'] === 'backorder') {
		tips.push('<div style="display: flex;">' +
			'<div class="material-icons v-icon" style="flex: 1 0 auto; align-items: baseline; margin-right: 5px;">event</div>' +
			'<div style="color: #000; font-size: 13px;"><span class="co-text-highlight">Temporarily Out of Stock.</span>' +
			' <span>You will be notified when this item is available and shipped.</span></div></div>');
	}

	if (globs['is_vie']) {
		tips.push("* If your order subtotal is over $50 the above shipping cost is covered by VIE and will not impact your students budget.");
		tips.push("* Your school must approve your order for processing, which may delay these estimates.");
	}

	return tips.join('<br/>');
}

export function customizeShippingLabel(label) {
	switch (label) {
		case 'Media Mail':
			return 'Economy';
		case 'UPS Ground' :
			return 'Standard';
	}

	return label;
}

export function customizeCertificateLabel(type, type_full, name, balance, hide_balance, inst_id) {
	let label;

	if (inst_id === 2698) { // unk
		label = `Charge up to <strong>$${balance}</strong> to <strong>${type_full}</strong>`;
	} else {
		label = `Apply ${type_full} <strong>${name}</strong> to this order`;
		if (inst_id === 1086) { // emu
			label = `Charge to your ${type_full} <strong>${name}</strong>`;
		} else if (inst_id === 2536) { // ferris
			label = `Use ${type_full}`;
		} else if (inst_id === 400 && !name) { // lynchburg
			label = `Charge to ${type_full}`;
		}

		if (!hide_balance || type !== 'voucher') {
			label += ` (Balance: <strong>$${balance}</strong>)`;
		}
	}

	return label;
}
